import {Box, Typography} from '@mui/material';
import React, {Fragment} from 'react';
import {Link} from 'react-router-dom';

import {MainFooter, MainHeader} from 'presentation/components';
import {Filter} from 'presentation/components/Filter';
import {StyledBreadcrumbs} from 'presentation/pages/private/uf-selection/styles';
import {translations} from 'presentation/translations-new';
import {LocalitiesList} from './components/LocalitiesList';
import {useLocalitiesSelection} from './hooks/useLocalitiesSelection';
import {LocalitiesSelectionProps} from './types';

const {locality} = translations['pt-br'].privateFlow.profile.locationSelection;
const {selectLocality, city, state} = translations['pt-br'].commons;

export function LocalitiesSelection({flowType}: LocalitiesSelectionProps) {
	const {handleClose, handleBack, bookingUfPath} = useLocalitiesSelection(flowType);

	return (
		<Fragment>
			<MainHeader
				title={selectLocality}
				handleBack={handleBack}
				handleClose={handleClose}
				variant="subRoute">
				<StyledBreadcrumbs>
					<Link to={bookingUfPath}>
						<Typography
							variant="body1"
							fontWeight={600}
							color="white"
							sx={{textDecoration: 'underline'}}>
							{state}
						</Typography>
					</Link>
					<Typography variant="body1" color="white">
						{city}
					</Typography>
				</StyledBreadcrumbs>
				<Filter.Root>
					<Filter.Search placeholder={locality.searchRegion} />
				</Filter.Root>
			</MainHeader>

			<LocalitiesList flowType={flowType} />

			<Box mt="auto">
				<MainFooter />
			</Box>
		</Fragment>
	);
}
